<div class="example-list" *ngIf="commitments" class="example-full-width">
    <commitment-row-details-toPrint fxLayout="column" fxFlex *ngFor="let commitment of commitments" [commitment]="commitment">
    </commitment-row-details-toPrint>
</div>      